import Tooltip from "@material-ui/core/Tooltip";
import Button from "@material-ui/core/Button";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import React, { Component } from "react";
export class BackIconButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      onClick: props.onClick,
      caption: props.caption,
    };
  }

  onClick() {
    if (this.state.onClick) {
      this.state.onClick();
    }
  }
  render() {
    return (
      <span onClick={this.onClick.bind(this)} style={{ cursor: "pointer" }}>
        {/* <Tooltip title="Back"> */}
        <Button
          type={this.state.type ? this.state.type : ""}
          id="ptsButton"
          variant="contained"
          startIcon={<ArrowBackIcon />}
          // style={{
          //   // background: "#6A7B8E",
          //   // color: "#fff",
          //   background: "#d3d8de",
          //   color: "#353538",
          //   // marginRight: "1rem",
          //   // marginBottom: "1em",
          //   textTransform: "capitalize",
          //   padding: "2px 10px",
          // }}
          onClick={this.onClick.bind(this)}
        >
          Back
        </Button>
        {/* </Tooltip> */}
      </span>
    );
  }
}
export default BackIconButton;
